import styles from "./Logo.module.css";

interface LogoProps {
  /** Render only the glyph (no wordmark). */
  markOnly?: boolean;
  size?: number;
}

/**
 * Cogent mark — two relay nodes joined by a signal arc: the bridge between a
 * Slack channel and an AI coding agent. Drawn in the citron accent so the brand
 * carries the product's single signature colour.
 */
export function Logo({ markOnly = false, size = 28 }: LogoProps) {
  return (
    <span className={styles.logo}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
        className={styles.mark}
      >
        {/* signal arc bridging the two nodes */}
        <path
          d="M9 22.5C4.8 21 3 17.9 3 14.5 3 9.3 7.6 5 13.3 5c4.2 0 7.8 2.3 9.4 5.7"
          stroke="var(--accent)"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <path
          d="M23 9.5c4.2 1.5 6 4.6 6 8 0 5.2-4.6 9.5-10.3 9.5-4.2 0-7.8-2.3-9.4-5.7"
          stroke="var(--accent)"
          strokeWidth="2.4"
          strokeLinecap="round"
          opacity="0.45"
        />
        {/* the two relay nodes */}
        <circle cx="9" cy="22.5" r="3" fill="var(--accent)" />
        <circle cx="23" cy="9.5" r="3" fill="var(--accent)" />
      </svg>
      {!markOnly && <span className={styles.word}>Cogent</span>}
    </span>
  );
}
